export const userDataSelector = (state) => state.user;
export const signInInProcessSelector = (state) => state.user.signInInProcess;
export const signInErrorsSelector = (state) => state.user.signInErrors;
export const localizationSelector = (state) => state.user.localization;
